//Login Module
export { default as SignInCard } from './SignIn/SignIn';
export { default as SignUpCard } from './SignUp/SignUp';
export { default as ResetPwdCard } from './ResetPwd/ResetPwd';
export { default as ForgotPwdCard } from './ForgotPwd/ForgotPwd';

//common card
export { default as CommonCard } from './SignIn/CommonCard';

//dashboard common layout
export { default as Header } from './Header/Header';
export { default as Footer } from './Footer/Footer';
export { default as Sidebar } from './Sidebar/Sidebar';
export { default as Modal } from './Modal/Modal';

//header
export { default as ProfileMenu } from './Header/ProfileMenu';

//Widget
export { default as AppearanceCard } from './Widget/AppearanceCard';
export { default as CreateWidgetCard } from './Widget/CreateWidget';
export { default as DataSourceCard } from './Widget/DataSourceCard';
export { default as IconCard } from './Widget/IconCard';
export { default as LayoutCard } from './Widget/LayoutCard';
export { default as PostCard } from './Widget/PostCard';
export { default as PopupCard } from './Widget/PopupCard';
export { default as PreviewCard } from './Widget/PreviewCard';
export { default as SettingCard } from './Widget/SettingCard';
export { default as SchemaCard } from './Widget/SchemaCard';
export { default as WidgetList } from './Widget/WidgetList';
export { default as FilterCard } from './Widget/FilterCard';
export { default as ChatLayoutCard, } from './Widget/ChatLayoutCard';
export { default as ChatAppearanceCard, } from './Widget/ChatAppearanceCard';
export { default as ChatDisplayRuleCard } from './Widget/ChatDisplayRuleCard';
export { default as ToolLayoutCard } from './Widget/ToolLayoutCard';
export { default as ToolAppearanceCard } from './Widget/ToolAppearanceCard';
export { default as ShopifyWidgetList } from './Widget/ShopifyWidgetList';
export { default as GetCodeCard } from './Widget/GetCodeCard';
export { default as CollectorLayoutCard } from './Widget/CollectorLayoutCard';
export { default as StoryWidgetDataCard } from './Widget/StoryWidgetDataCard';
export { default as DataCollectCard } from './Widget/DataCollectCard';
export { default as AutomationCard } from './Widget/AutomationCard';
export { PostToggleCard, SelectTemplateCard, CtaLableCard, CustomWidthCard, CmnCustomizeCard } from './Widget/CustomizeCard';
export { default as AnalyticCard } from './Widget/AnalyticCard';
export { default as DatasourceIntegration } from './Widget/DatasourceIntegration';
export { default as WidgetHeader } from './Widget/WidgetHeader';
export { default as InstafeedHeader } from './Widget/InstafeedHeader';
export { default as UpgradePlanCard } from './Widget/UpgradePlanCard';

// export { default as EditWall } from './Wall/EditWall';
// export { default as DesignCard } from './Wall/DesignCard';
// export { default as WallDesignCard } from './Wall/WallDesignCard';

//integration
export { default as FacebookPost } from './Integration/FacebookPost';
export { default as FacebookReview } from './Integration/FacebookReview';
export { default as GooglePost } from './Integration/GooglePost';
export { default as GoogleReview } from './Integration/GoogleReview';
export { default as ReviewModel } from './Review/ReviewModel';
export { default as PostModel } from './Post/PostModel';
export { default as TwitterPost } from './Integration/TwitterPost';
export { default as InstaPost } from './Integration/InstaPost';
export { default as GooglePlace } from './Integration/GooglePlace';
export { default as Capterra } from './Integration/Capterra';
export { default as RSS } from './Integration/RSS';
export { default as Tumblr } from './Integration/Tumblr';
export { default as Booking } from './Integration/Booking';
export { default as TripAdvisor } from './Integration/TripAdvisor';
export { default as Trustpilot } from './Integration/Trustpilot';
export { default as Airbnb } from './Integration/Airbnb';
export { default as Hotels } from './Integration/Hotels';
export { default as Yelp } from './Integration/Yelp';
export { default as Etsy } from './Integration/Etsy';
export { default as Houzz } from './Integration/Houzz';
export { default as Edmunds } from './Integration/Edmunds';
export { default as DealerRater } from './Integration/DealerRater';
export { default as OpenTable } from './Integration/OpenTable';
export { default as Ebay } from './Integration/eBay';
export { default as BBB } from './Integration/BBB';
export { default as Amzon } from './Integration/Amzon';
export { default as GooglePlay } from './Integration/GooglePlay';
export { default as AppleApp } from './Integration/AppleApp';
export { default as AppSumo } from './Integration/AppSumo';
export { default as Webhook } from './Integration/Webhook';
export { default as CustomReview } from './Integration/CustomReview';
export { default as CustomWebhook } from './Integration/CustomWebhook';
export { default as CustomCollectorReview } from './Integration/CustomCollectorReview';
export { default as Aliexpress } from './Integration/Aliexpress';
export { default as G2 } from './Integration/G2';
export { default as YouTubeVideoGallery } from './Integration/YouTubeVideoGallery';
export { default as Stamped } from './Integration/Stamped';
export { default as ImportReviews } from './Integration/ImportReviews';
export { default as TwitterTestimonial } from './Integration/TwitterTestimonial';

//pixel
export { default as InstallCard } from './Pixel/InstallCard';

//Review Modal
export { default as ReviewData } from './ReviewData/ReviewData';

// //plan
// export { default as PlanCard } from './Plan/PlanCard';

//payment
export { default as InvoiceCard } from './Payment/InvoiceCard';
export { default as ShopifyInvoiceCard } from './Payment/ShopifyInvoiceCard';
export { default as PaymentCard } from './Payment/PaymentCard';

//instafeed 
export { default as InstaFeedIntegration } from './InstaFeedIntegration/InstaFeedIntegration';



// WEBPACK FOOTER //
// ./src/components/index.js